import { CardItem } from './CardItem';
import {
  MastHead,
  MastHeadBackground,
  MastHeadContent,
  MastHeadTitle,
  MastHeadSubtitle,
  MastHeadDescription,
  MastHeadActions,
} from './MastHead';
import { AWMSButton } from '../Common/Buttons/AWMSButton';
import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router';

export const AWMSLanding = () => {
  // Fetch user info from OIDC context
  const auth = useAuth();
  const firstName = (auth.user?.profile['preferred_name'] as string) ?? auth.user?.profile.given_name ?? 'there';

  const academicsContent =
    'This area provides a list of staff in your school. You can manage workload allocations from the staff perspective.';
  const unitsContent =
    'This area provides a list of units in your school. Here you can manage workload from the unit perspective.';
  const reportsContent =
    'View reporting data associated with workload allocations from school, staff and unit perspectives.';

  return (
    <div className="w-full overflow-auto bg-white">
      <MastHead className="min-h-[340px] lg:min-h-[540px] bg-[url('/banner.jpg')] bg-cover bg-no-repeat bg-[position:center_40%]">
        <MastHeadBackground className="absolute inset-0 bg-[linear-gradient(to_right,rgba(13,13,13,0.65)_0%,rgba(13,13,13,0.32)_40%,rgba(0,0,0,0)_100%)] pointer-events-none" />
        <div className="relative z-10 mx-auto flex w-full flex-col gap-6 px-4 lg:w-[60%]">
          <MastHeadContent>
            <MastHeadTitle>Hi {firstName}!</MastHeadTitle>
            <MastHeadSubtitle>Welcome to your Academic Workload Management System</MastHeadSubtitle>
            <MastHeadDescription>
              You can use the Academic Workload Management System (AWMS) to manage workload for academic staff or unit
              allocation in your school.
            </MastHeadDescription>
            <MastHeadActions>
              <Link to="/staffs">
                <AWMSButton variant="primary" icon>
                  Launch AWMS
                </AWMSButton>
              </Link>
              <a
                href="https://staffportal.curtin.edu.au/employment/performance-planning/awms/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AWMSButton variant="secondary" icon>
                  Learn more about AWMS
                </AWMSButton>
              </a>
            </MastHeadActions>
          </MastHeadContent>
        </div>
      </MastHead>

      {/* Main content below masthead */}
      <div className="flex-1 w-full px-4 pb-20 lg:w-[60%] mx-auto">
        <div className="mb-2 mt-2 text-5xl font-bold leading-[60px]">Suggested shortcuts</div>
        <div>
          AWMS consists of three key areas. Once you launch the app, you can navigate between these. However if you need
          a shortcut, you can access it from here.
        </div>
        <div className="mt-16 flex flex-col justify-between gap-8 lg:flex-row">
          <CardItem
            title="School staff"
            content={academicsContent}
            footer="View school staff list"
            navigationLink="/staffs"
          />
          <CardItem
            title="School units"
            content={unitsContent}
            footer="View school units list"
            navigationLink="/unit-workloads"
          />
          <CardItem
            title="Reports"
            content={reportsContent}
            footer="Navigate to reporting"
            navigationLink="/reports"
          />
        </div>
      </div>
    </div>
  );
};
